export const CHECKOUT_URL =
  'https://checkout.ebookbtnlines.shop/cart/45733353619503:1'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/binUNaMgDw7FEBvqjETFVy/IMG_9617.png'

export type Problem = {
  icon: 'DollarSign' | 'Calculator' | 'Percent' | 'TrendingDown' | 'BarChart3'
  title: string
  description: string
}

export const problems: Problem[] = [
  {
    icon: 'DollarSign',
    title: 'Vendés… pero nunca te queda plata',
    description:
      'Trabajás todo el mes, llegan ventas constantemente, pero cuando hacés cuentas sentís que el dinero desaparece y no entendés por qué.',
  },
  {
    icon: 'Calculator',
    title: 'No sabés si tus precios están bien',
    description:
      'Ponés los precios mirando a la competencia o aumentando "un poco", pero nunca tenés la seguridad de estar cobrando lo que realmente corresponde.',
  },
  {
    icon: 'Percent',
    title: 'Hacés promociones sin saber si ganás o perdés',
    description:
      'Lanzás descuentos, combos o promociones para vender más, pero nunca calculás cuánto impactan realmente en tu rentabilidad.',
  },
  {
    icon: 'TrendingDown',
    title: 'Sentís que trabajás cada vez más para ganar lo mismo',
    description:
      'Aumentan los costos, aumentan los proveedores y cada vez cuesta más mantener la rentabilidad del negocio.',
  },
  {
    icon: 'BarChart3',
    title: 'Tomás decisiones por intuición',
    description:
      'No tenés números claros para decidir qué productos conviene vender, cuáles dejan más ganancia o cuánto necesitás facturar para llegar tranquilo a fin de mes.',
  },
]

export type Outcome = {
  icon: 'Wallet' | 'Tag' | 'Gift' | 'LineChart' | 'Sprout'
  title: string
  description: string
}

export const outcomes: Outcome[] = [
  {
    icon: 'Wallet',
    title: 'Saber cuánto ganás realmente',
    description:
      'Dejá de adivinar. Conocé exactamente cuánto dinero te deja cada producto que vendés.',
  },
  {
    icon: 'Tag',
    title: 'Poner precios con seguridad',
    description:
      'Aprendé a calcular precios correctamente sin regalar tu trabajo ni perder clientes.',
  },
  {
    icon: 'Gift',
    title: 'Crear promociones rentables',
    description:
      'Descubrí qué promociones realmente aumentan tus ventas sin destruir tu margen de ganancia.',
  },
  {
    icon: 'LineChart',
    title: 'Tomar decisiones con números',
    description:
      'Dejá de manejar tu negocio por intuición y empezá a decidir con información clara.',
  },
  {
    icon: 'Sprout',
    title: 'Tener un negocio más rentable',
    description:
      'Con pequeños cambios en costos, precios y promociones podés mejorar la rentabilidad sin necesidad de vender el doble.',
  },
]

export type Tomo = {
  number: string
  title: string
  items: string[]
}

export const tomos: Tomo[] = [
  {
    number: 'TOMO 1',
    title: '¿Tu negocio gana plata o solo factura?',
    items: [
      'Facturación vs. ganancia.',
      'Costos fijos y variables.',
      'Gastos invisibles.',
      'Cómo ordenar las finanzas del negocio.',
      'Errores que hacen perder dinero.',
      'Checklist de diagnóstico financiero.',
    ],
  },
  {
    number: 'TOMO 2',
    title: 'Calculá el costo real de cada producto',
    items: [
      'Materia prima.',
      'Insumos.',
      'Packaging.',
      'Mano de obra.',
      'Envíos y comisiones.',
      'Costos ocultos.',
      'Planilla práctica para calcular costos.',
    ],
  },
  {
    number: 'TOMO 3',
    title: '¿Estás cobrando lo que deberías?',
    items: [
      'Cómo fijar precios.',
      'Margen y rentabilidad.',
      'Cómo actualizar precios.',
      'Cómo comunicar aumentos.',
      'Casos prácticos.',
      'Errores frecuentes.',
    ],
  },
  {
    number: 'TOMO 4',
    title: 'Promociones que venden sin hacerte perder plata',
    items: [
      'Descuentos rentables.',
      'Combos.',
      'Packs.',
      'Segunda unidad.',
      'Regalos.',
      'Cómo calcular promociones.',
      'Cómo medir resultados.',
    ],
  },
  {
    number: 'TOMO 5',
    title: 'Cómo ganar más sin vender el doble',
    items: [
      'Ticket promedio.',
      'Venta cruzada.',
      'Productos complementarios.',
      'Productos más rentables.',
      'Cómo tomar mejores decisiones.',
      'Estrategias para aumentar la rentabilidad.',
    ],
  },
  {
    number: 'TOMO 6',
    title: 'El sistema de control de tu negocio',
    items: [
      'Indicadores clave.',
      'Dashboard mensual.',
      'Punto de equilibrio.',
      'Checklist semanal.',
      'Checklist mensual.',
      'Cómo analizar el rendimiento del negocio.',
    ],
  },
]

export type Testimonial = {
  name: string
  business: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Valentina',
    business: 'Tienda de indumentaria',
    quote:
      'Descubrí que tenía productos que prácticamente no me dejaban ganancia. Ajusté los precios y hoy vendo con mucha más tranquilidad.',
  },
  {
    name: 'Nicolás',
    business: 'Local de accesorios',
    quote:
      'Siempre hacía promociones porque pensaba que vendía más. Con la calculadora entendí cuáles realmente me convenían.',
  },
  {
    name: 'Camila',
    business: 'Emprendedora de cosmética',
    quote:
      'Por primera vez sé exactamente cuánto gano con cada producto que vendo.',
  },
  {
    name: 'Martín',
    business: 'Tienda de regalos',
    quote:
      'El dashboard me cambió la forma de manejar el negocio. Ahora reviso mis números todas las semanas.',
  },
  {
    name: 'Lucía',
    business: 'Emprendimiento gastronómico',
    quote:
      'Pensaba que mi problema era vender poco. En realidad estaba poniendo mal los precios.',
  },
]

export type Bonus = {
  label: string
  title: string
}

export const bonuses: Bonus[] = [
  { label: 'Bono 1', title: 'Calculadora de promociones rentables' },
  {
    label: 'Bono 2',
    title: 'Calculadora para actualizar precios automáticamente',
  },
  {
    label: 'Bono 3',
    title:
      'Calendario comercial argentino con ideas de campañas y promociones para todo el año',
  },
  {
    label: 'Bono 4',
    title:
      'Checklist mensual para controlar la salud financiera de tu negocio',
  },
]

export type OfferItem = {
  emoji: string
  text: string
}

export const offerIncludes: OfferItem[] = [
  { emoji: '📚', text: 'Los 6 tomos completos del sistema Negocio Rentable' },
  { emoji: '🧾', text: 'Planilla para calcular el costo real de cada producto' },
  { emoji: '🏷️', text: 'Calculadora de precios y márgenes' },
  { emoji: '📊', text: 'Dashboard mensual de control del negocio' },
  { emoji: '✅', text: 'Checklists semanales y mensuales' },
  { emoji: '⚡', text: 'Acceso inmediato y de por vida, con actualizaciones' },
]

export const bonusEmojis: string[] = ['🧮', '💹', '📅', '🩺']
